import Link from '@cartwhl/common/components/Link';
import Text from '@cartwhl/ui/base/Text';

export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB in bytes

export const VIDEO_EXTENSIONS = [
  '.3gp',
  '.avi',
  '.flv',
  '.m4v',
  '.mkv',
  '.mov',
  '.mp4',
  '.webm',
  '.wmv',
];

export const ModalConfig = {
  'file picker': {
    title: 'Upload video',
    maxWidth: 547,
  },
  'media capture': {
    title: (
      <div className="flex w-full flex-col justify-between sm:flex-row">
        <Text variant="studio/title/lg" className="mb-1">
          Capture video
        </Text>
        <Text
          variant="studio/body/medium/sm"
          className="text-gray-60 dark:text-gray-45"
        >
          For more details see our{' '}
          <Link
            className="text-blue"
            href="https://docs.getcartwheel.com/docs/creating-motion/video-to-motion"
            target="_blank"
          >
            video documentation
          </Link>
          .
        </Text>
      </div>
    ),
    maxWidth: 971,
  },
  'trimming start': {
    title: (
      <>
        <div className="flex flex-col lg:hidden">
          <Text as="div" variant="studio/body/medium/sm" className="mb-1.5">
            Step 1 of 3
          </Text>
          <Text variant="studio/title/lg">Review & trim video</Text>
        </div>
        <div className="hidden w-full flex-row justify-between lg:flex">
          <Text variant="studio/title/lg">Review & trim video</Text>
          <Text
            as="p"
            variant="studio/body/medium/sm"
            className="text-gray-60 dark:text-gray-45"
          >
            Trim video to a{' '}
            <span className="text-gray-90 dark:text-white">
              maximum of 30 secs
            </span>
            .
          </Text>
        </div>
      </>
    ),
    maxWidth: 971,
  },
  'trimming end': {
    title: (
      <>
        <div className="flex flex-col lg:hidden">
          <Text variant="studio/body/medium/sm" as="div" className="mb-1.5">
            Step 2 of 3
          </Text>
          <Text variant="studio/title/lg">Review & trim video</Text>
        </div>
        <div className="hidden w-full flex-row justify-between lg:flex">
          <Text variant="studio/title/lg">Review & trim video</Text>
          <Text
            as="p"
            variant="studio/body/medium/sm"
            className="text-gray-60 dark:text-gray-45"
          >
            Trim video to a{' '}
            <span className="text-gray-90 dark:text-white">
              maximum of 30 secs
            </span>
            .
          </Text>
        </div>
      </>
    ),
    maxWidth: 971,
  },
  cropping: {
    title: (
      <>
        <div className="flex flex-col lg:hidden">
          <Text as="div" variant="studio/body/medium/sm" className="mb-1.5">
            Step 3 of 3
          </Text>
          <Text variant="studio/title/lg">Crop & rotate</Text>
          <Text
            variant="studio/body/sm"
            className="text-gray-60 dark:text-gray-45 mt-2"
          >
            Crop and rotate to focus on the person to track.
          </Text>
        </div>
        <div className="hidden w-full flex-row justify-between lg:flex">
          <Text variant="studio/title/lg">Crop & rotate</Text>
          <div className="text-gray-60 dark:text-gray-45">
            Crop and rotate to focus on the person to track.
          </div>
        </div>
      </>
    ),
    maxWidth: 971,
  },
  upload: {
    title: 'Upload video',
    maxWidth: 547,
  },
};
